import { NgModule } from '@angular/core';
import { RatingStarAvgPipe } from './rating-star-avg.pipe';

@NgModule({
	declarations: [RatingStarAvgPipe],
	exports: [RatingStarAvgPipe],
	providers: [RatingStarAvgPipe]
})
export class RatingStarAvgPipeModule {}
